const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <section className="section-padding bg-white dark:bg-gray-900">
        <div className="container-custom max-w-4xl text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">About Deoriginlabs</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">We help learners become job-ready DevOps and Cloud engineers with hands-on training, mentorship, and placement support.</p>
        </div>
      </section>
    </div>
  )
}

export default About
